



























































































































































































































































































































































































































































































































































import { Component , Prop, Watch } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwSpinningProgress } from '@sonicwall/unified-ui-framework/src/shared/sw-progress';
import { SwTextfield } from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';
import { SwIcon } from '@sonicwall/unified-ui-framework/src/shared/sw-icon';
import { SwRadio } from '@sonicwall/unified-ui-framework/src/shared/sw-radio';
import { SwToggle } from '@sonicwall/unified-ui-framework/src/shared/sw-toggle';
import { SwCountryChoose } from '../../../shared/country-selector';
import { DropdownLight } from '../../../shared/dropdown-light';
import { SwSelect, SelectOption } from '@sonicwall/unified-ui-framework/src/shared/sw-select';
import { tooltip } from '@libs-uuif/shared/tooltip-dir';
import RegexValidators from '../../../shared/regex-validators';

const regexValidChars = /^[a-z0-9-]+$/;
const regexStartsWithLetter = /^[a-z]/;
const regexLength = /^.{4,30}$/;

const cssPrefix = 'register-products';
@Component({
  components: {
    SwSpinningProgress,
    SwTextfield,
    SwIcon,
    SwRadio,
    SwToggle,
    SwCountryChoose,
    DropdownLight,
    SwSelect,
  },
  directives: {
    tooltip,
  },
})
export default class ManagementOption extends SwExtendedVue {
  cssPrefix = cssPrefix;
  countryCodeCSC : string = '';
  fwManaged : string = 'Unmanaged';
  firewallManaged : string = 'Unmanaged';
  switchValue : string = 'Firewall';
  dataCenterOption: SelectOption[] = [];
  casDataCenterOption: SelectOption[] = [];
  casAppOption: SelectOption[] = [];
  outBoundOptions: SelectOption[] = [];
  casDataCeter : string = '';
  sasDataCenter : string = '';
  cesDataCenter : string = '';
  sseDataCenter: string = '';
  ccClientDataCenter : string = '';
  casApp :string = '';
  @Prop({ required: true })
  pageToShow: any;
  managementOptData : any = [];
  @Prop({ type: Object, required: true })
  managementOpt :any;
  @Prop({ type: Object })
  validateSerialNumberData :any;
  gmsOnPremiseOpt: SelectOption[] = [];
  ccClientOpt: SelectOption[] = [];
  gmsOnPremise : string = '';
  fwGmsOnPremiseOpt: SelectOption[] = [];
  fwGmsOnPremise : string = '';
  arrListOffSite: SelectOption[] = [];
  arrList : string = '';
  ispSwitch : boolean = false;
  cscZeroTouch : boolean = false;
  gmsZeroTouch : boolean = false;
  cscZeroTouchfw : boolean = false;
  gmsZeroTouchfw : boolean = false;
  ztIpText :string = '';
  fwZtIpText :string = '';
  dataModel = {
    dataCenterValue : '',
    dataCenter : '',
    domainName : '',
    confirmName : '',
    inboundIpAddress : '',
    outboundIpAddress: '',
    email: '',
    password: '',
    confirmPassword: '',
  };
  gmsConfiguration = {
    ttserverurl: '',
    ttserverfqdn: '',
  };
  policyServerValidator =  false;
  ttserverurlValidator = false;
  ttserverfqdnValidator = false;
  countryList : any;
  catpDcList: any;
  mdrDcList: any;
  selectedCATPdc: any = '';
  selectedMDRdc: any = '';
  casDomainName: string = '';
  tseDataCenter: string = '';
  casDomainValidator : boolean = false;
  casConfirmName: string = '';
  sasDomainName : string = '';
  sasConfirmName : string  = '';
  sasDomainValidator : boolean = false;
  cesDomainName : string = '';
  cesConfirmName : string  = '';
  cesDomainValidator : boolean = false;
  sseSubdomainName: string = '';
  sseDomainValidator: boolean = false;
  sseSubdomainError: string = '';
  hesDomainNameValidator : boolean = false;
  hostNameRegex = new RegExp('^(?!.* .*)(?:[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9]\.)+[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9]$');
  hostNameRegexValidator = new RegExp('^(?!.* .*)(?:[a-zA-Z0-9]{0,61}[a-zA-Z0-9][.:-])+[a-zA-Z0-9]{0,61}[a-zA-Z0-9]$');
  subdomainRegex = new RegExp(RegexValidators.subdomainPattern);
  cloudTenantList: SelectOption[] = [];
  cloudTenantSelected : string = '';
  @Prop({ required: true })
  mangOptRequiredflag : any;
  @Watch('gmsOnPremise')
  onDropDownChange(value : any) {
    this.ztIpText = value;
  }

  @Watch('fwGmsOnPremise')
  onFwDropDownChange(value : any) {
    this.fwZtIpText = value;
  }

  @Watch('casDomainName')
  onDomainNameChange() {
    console.warn('testing 1');
    console.warn(!this.casDomainName.match(this.hostNameRegex));
    if (!this.casDomainName.match(this.hostNameRegex)) {
      this.casDomainValidator = true;
    } else {
      this.casDomainValidator = false;
    }
  }
//   @Watch('gmsConfiguration.policyServer')
//   policyServerChange() {
//     if (!this.gmsConfiguration.policyServer.match(this.hostNameRegexValidator)) {
//       this.policyServerValidator = true;
//     } else {
//       this.policyServerValidator = false;
//     }
//   }
  @Watch('gmsConfiguration.ttserverurl')
  ttserverurlChange() {
    if (!this.gmsConfiguration.ttserverurl.match(this.hostNameRegexValidator)) {
      this.ttserverurlValidator = true;
    } else {
      this.ttserverurlValidator = false;
    }
  }
  @Watch('gmsConfiguration.ttserverfqdn')
  ttserverfqdnChange() {
    if (!this.gmsConfiguration.ttserverfqdn.match(this.hostNameRegexValidator)) {
      this.ttserverfqdnValidator = true;
    } else {
      this.ttserverfqdnValidator = false;
    }
  }

  @Watch('sasDomainName')
  onSASDomainNameChange() {
    if (!this.sasDomainName.match(this.hostNameRegex)) {
      this.sasDomainValidator = true;
    } else {
      this.sasDomainValidator = false;
    }
  }

  @Watch('cesDomainName')
  onCESDomainNameChange() {
    if (!this.cesDomainName.match(this.hostNameRegex)) {
      this.cesDomainValidator = true;
    } else {
      this.cesDomainValidator = false;
    }
  }

  @Watch('sseSubdomainName')
  onSSESubdomainNameChange() {
    this.sseSubdomainError = '';

    if (!regexStartsWithLetter.test(this.sseSubdomainName)) {
      this.sseSubdomainError = `${this.$t('registerProduct.cseNameStartsWith')}`;
    } else if (!regexValidChars.test(this.sseSubdomainName)) {
      this.sseSubdomainError = `${this.$t('registerProduct.cseNameInvalid')}`;
    } else if (!regexLength.test(this.sseSubdomainName)) {
      this.sseSubdomainError = `${this.$t('registerProduct.cseNameLengthError')}`;
    }
    this.sseDomainValidator = !!this.sseSubdomainError;
  }

  @Watch('dataModel.domainName')
  onHesDomainNameChange() {
    console.warn(!this.dataModel.domainName.match(this.hostNameRegex));
    if (!this.dataModel.domainName.match(this.hostNameRegex)) {
      this.hesDomainNameValidator = true;
    } else {
      this.hesDomainNameValidator = false;
    }
  }

  ispSwitched(value : any) {
    if (!value) {
      this.dataModel.outboundIpAddress =  '';
    } else if (value) {
      this.outBoundOptions = [];
      let ind : any;
      this.managementOpt.response[this.pageToShow.hesFieldNo].content.hesDc.forEach((element : any, index : any) => {
        if (element.dataCenterLocationId === this.dataModel.dataCenterValue) {
          ind = index;
        }
      });
      this.managementOpt.response[this.pageToShow.hesFieldNo].content.hesDc[ind].sharedOutBound.forEach((element : any) => {
        const inner : any = {};
        inner['id'] = element.textSourceISP;
        inner['label'] = element.textSourceISP;
        inner['value'] = element.valueOutBoundIP;
        this.outBoundOptions.push(inner);
      });
      this.dataModel.outboundIpAddress = this.outBoundOptions[0].id;
    }
  }

  @Watch('dataModel.dataCenterValue' , { deep : true })
  dataCenterChanged() {
    this.ispSwitch ? this.ispSwitched(true) : this.ispSwitched(false);
  }

  @Watch('dataModel.domainName', { deep : true })
  locationIdChanged(value : any) {
    const literal = 'admin@';
    this.dataModel.email = literal + value;
  }

  @Watch('managementOpt', { deep:true , immediate:true })
  onManagementOptChange() {
    console.warn(this.pageToShow);
    this.fwManaged  = 'Unmanaged';
    this.firewallManaged = 'Unmanaged';
    this.dataCenterOption = [];
    this.casDataCenterOption = [];
    this.outBoundOptions = [];
    this.$emit('managementData', this.managementOptData);
    const response = this.managementOpt.response;
    if (this.pageToShow.tseCount === 1) {
      response[this.pageToShow.tseFieldNo].content.casDataCenter.forEach((element : any) => {
        const inner : any = {};
        inner['id'] = element.dataCenterId;
        inner['label'] = element.dataCenterDesc;
        inner['value'] = element.dataCenterName;
        this.casDataCenterOption.push(inner);
      });
      this.tseDataCenter = this.casDataCenterOption[0].id.toString();
    }
    if (this.pageToShow.tsemdrCount === 1) {
      response[this.pageToShow.tsemdrFieldNo].content.casDataCenter.forEach((element : any) => {
        const inner : any = {};
        inner['id'] = element.dataCenterId;
        inner['label'] = element.dataCenterDesc;
        inner['value'] = element.dataCenterName;
        this.casDataCenterOption.push(inner);
      });
      this.tseDataCenter = this.casDataCenterOption[0].id.toString();
    }
    if (this.pageToShow.casCount === 1) {
      response[this.pageToShow.casFieldNo].content.casDataCenter.forEach((element : any) => {
        const inner : any = {};
        inner['id'] = element.dataCenterId;
        inner['label'] = element.dataCenterDesc;
        inner['value'] = element.dataCenterName;
        this.casDataCenterOption.push(inner);
      });
      if (response[this.pageToShow.casFieldNo].content.isShowCasApp) {
        response[this.pageToShow.casFieldNo].content.casbAppList.forEach((element : any) => {
          const inner : any = {};
          inner['id'] = element.appValue;
          inner['label'] = element.appName;
          inner['value'] = element.appValue;
          this.casAppOption.push(inner);
        });
        this.casApp = this.casAppOption[0].id;
      }
      this.casDataCeter = this.casDataCenterOption[0].id.toString();
    }
    if (this.pageToShow.sasCount === 1) {
      response[this.pageToShow.sasFieldNo].content.casDataCenter.forEach((element : any) => {
        const inner : any = {};
        inner['id'] = element.dataCenterId;
        inner['label'] = element.dataCenterDesc;
        inner['value'] = element.dataCenterName;
        this.casDataCenterOption.push(inner);
      });
      console.warn(this.casDataCenterOption[0].id.toString());
      this.sasDataCenter = this.casDataCenterOption[0].id.toString();
    }
    if (this.pageToShow.cesCount === 1) {
      response[this.pageToShow.cesFieldNo].content.casDataCenter.forEach((element : any) => {
        const inner : any = {};
        inner['id'] = element.dataCenterId;
        inner['label'] = element.dataCenterDesc;
        inner['value'] = element.dataCenterName;
        this.casDataCenterOption.push(inner);
      });
      this.cesDataCenter = this.casDataCenterOption[0].id.toString();
    }
    if (this.pageToShow.sseCount === 1) {
      response[this.pageToShow.sseFieldNo].content.casDataCenter.forEach((element : any) => {
        const inner : any = {};
        inner['id'] = element.dataCenterId;
        inner['label'] = element.dataCenterDesc;
        inner['value'] = element.dataCenterName;
        this.casDataCenterOption.push(inner);
      });
      this.sseDataCenter = this.casDataCenterOption[0].id.toString();
    }
    if (this.pageToShow.hesCount === 1) {
      response[this.pageToShow.hesFieldNo].content.hesDc.forEach((element : any) => {
        const inner : any = {};
        inner['id'] = element.dataCenterLocationId;
        inner['label'] = element.dataCenterName;
        inner['value'] = element.dataCenterName;
        this.dataCenterOption.push(inner);
      });
      this.dataModel.dataCenterValue = this.dataCenterOption[0].id;
      if (response[this.pageToShow.hesFieldNo].content.hesDc[0].sharedOutBound) {
        response[this.pageToShow.hesFieldNo].content.hesDc[0].sharedOutBound.forEach((element : any) => {
          const inner : any = {};
          inner['id'] = element.valueOutBoundIP;
          inner['label'] = element.textSourceISP;
          inner['value'] = element.textSourceISP;
          this.outBoundOptions.push(inner);
        });
        // this.dataModel.outboundIpAddress = this.outBoundOptions[0].id;
      }
    }
    if (this.pageToShow.wifiCount > 0) {
      this.pageToShow.wfGMSManaged ? this.setGmsOnpremiseData(this.pageToShow.gmsFieldNo) : '' ;
      // tslint:disable-next-line:max-line-length
      if (this.pageToShow.wfCSCManaged && this.pageToShow.wifiFieldNo !== -1) {
        this.setCMSarrListOffSite(this.pageToShow.wifiFieldNo);
      }
      this.countryList = response[this.pageToShow.countryListFieldNo].content.countryList;
    }
    if (this.pageToShow.firewallCount > 0) {
      this.pageToShow.fwGMSManaged ? this.setGmsOnpremiseData(this.pageToShow.gmsFieldNo, 'firewall') : '' ;
      // tslint:disable-next-line:max-line-length
      if (this.pageToShow.fwCSCManaged && this.pageToShow.firewallFieldNo !== -1) {
        this.setCMSarrListOffSite(this.pageToShow.firewallFieldNo);
      } else if (this.pageToShow.arrListFieldNo > 0) {
        this.setCMSarrListOffSite(this.pageToShow.arrListFieldNo);
      }
      if (this.pageToShow.cloudTenantFieldNo > -1) {
        this.managementOpt.response[this.pageToShow.cloudTenantFieldNo].content.cloudlist.forEach((ele : any) => {
          const inner : any = {};
          inner['id'] = ele.serialnumber;
          inner['label'] = ele.datacenter;
          inner['value'] = ele.serialnumber;
          this.cloudTenantList.push(inner);
        });
        this.cloudTenantSelected = this.cloudTenantList[0].id;
        console.warn(this.cloudTenantList);
      }
    }
    if (this.pageToShow.ccClientCount > 0) {
      this.ccClientOpt = [];
      response[this.pageToShow.ccClientFieldNo].content.casDataCenter.forEach((element : any) => {
        const inner : any = {};
        inner['id'] = element.dataCenterId;
        inner['label'] = element.dataCenterDesc;
        inner['value'] = element.dataCenterName;
        this.ccClientOpt.push(inner);
      });
      console.warn(this.ccClientOpt[0].id.toString());
      this.ccClientDataCenter = this.ccClientOpt[0].id.toString();
    }
  }

  @Watch('fwManaged')
  fwManagedChanged() {
    this.cscZeroTouchfw = false;
    this.gmsZeroTouchfw = false;
  }

  @Watch('firewallManaged')
  firewallManagedChanged() {
    this.cscZeroTouch = this.validateSerialNumberData?.isMpssZeroTouch || false;
    this.gmsZeroTouch = false;
  }

  setCATPdcList(field: any) {
    console.warn(this.managementOpt.response[field].content.arrCaptureAtpDc);
    this.catpDcList = [];
    const inner : any = {};
    inner['id'] = 'default';
    inner['label'] = 'Choose Location';
    inner['value'] = 'noChange';
    this.catpDcList.push(inner);
    this.selectedCATPdc = this.catpDcList[0].id;
    this.managementOpt.response[field].content.arrCaptureAtpDc.forEach((element : any) => {
      const inner : any = {};
      inner['id'] = element.locationID;
      inner['label'] = element.locationName;
      inner['value'] = element.locationName;
      this.catpDcList.push(inner);
      if (element.selected) this.selectedCATPdc = element.locationID;
    });
  }

  setMDRdcList(field: any) {
    console.warn(this.managementOpt.response[field].content.arrCaptureAtpDc);
    this.mdrDcList = [];
    const inner : any = {};
    inner['id'] = 'default';
    inner['label'] = 'Choose Location';
    inner['value'] = 'noChange';
    this.mdrDcList.push(inner);
    this.selectedMDRdc = this.mdrDcList[0].id;
    this.managementOpt.response[field].content.mdrDataCenter.forEach((element : any) => {
      const inner : any = {};
      inner['id'] = element.dataCenterId;
      inner['label'] = element.dataCenterDesc;
      inner['value'] = element.dataCenterDesc;
      this.mdrDcList.push(inner);
      if (element.isDefaultDC) this.selectedMDRdc = element.dataCenterId;
    });
  }

  created() {
    const options = this.managementOpt?.response[this.pageToShow?.switchFieldNo]?.content?.switchoptions;
    if (options && options.length) {
      const defaultOption = options.find((opt: any) => opt.order === 1);
      if (defaultOption) {
        this.switchValue = defaultOption.name;
      }
    }
    this.pageToShow.wifiCount > 0 ? this.countryList = this.managementOpt.response[this.pageToShow.countryListFieldNo].content.countryList : '';
    this.pageToShow.captDcListFieldNo > 0 && this.setCATPdcList(this.pageToShow.captDcListFieldNo);
    this.pageToShow.mdrDcListFieldNo > 0 && this.setMDRdcList(this.pageToShow.mdrDcListFieldNo);
    this.cscZeroTouch = this.validateSerialNumberData?.isMpssZeroTouch || false;
    if (this.pageToShow.wfCSCManaged) {
      this.fwManaged = 'CSCManagement';
    } else {
      this.fwManaged = 'Unmanaged';
    }
    if (this.pageToShow.fwCSCManaged) {
      this.firewallManaged = 'CSCManagement';
    } else {
      this.firewallManaged = 'Unmanaged';
    }
  }

  setCMSarrListOffSite(field : any) {
    this.arrListOffSite = [];
    const inner : any = {};
    inner['id'] = 'default';
    inner['label'] = 'Choose Location';
    inner['value'] = 'noChange';
    this.arrListOffSite.push(inner);
    this.managementOpt.response[field].content.arrListOffSite.forEach((element : any) => {
      const inner : any = {};
      inner['id'] = element.locationID;
      inner['label'] = element.locationName;
      inner['value'] = element.locationName;
      this.arrListOffSite.push(inner);
    });
    this.arrList = this.arrListOffSite[0].id;
  }

  setGmsOnpremiseData(field: any, val ?:any) {
    this.gmsOnPremiseOpt = [];
    this.fwGmsOnPremiseOpt = [];
    const inner : any = {};
    inner['id'] = 'default';
    inner['label'] = 'Choose On-Premise GMS Server';
    inner['value'] = 'noChange';
    val === 'firewall' ? this.fwGmsOnPremiseOpt.push(inner) : this.gmsOnPremiseOpt.push(inner);
    console.warn(this.managementOpt);
    console.warn(field);
    this.managementOpt.response[field].content.arrPolicyServerResult.forEach((element : any) => {
      const inner : any = {};
      inner['id'] = element.ttserverfqdnurl;
      inner['label'] = element.DisplayName;
      inner['value'] = element.PolicyServerUrl ;
      val === 'firewall' ? this.fwGmsOnPremiseOpt.push(inner) : this.gmsOnPremiseOpt.push(inner);
    });
    val === 'firewall' ? this.fwGmsOnPremise = this.fwGmsOnPremiseOpt[0].id : this.gmsOnPremise = this.gmsOnPremiseOpt[0].id;
  }

  countryCode(value : any) {
    this.countryCodeCSC = value;
    console.warn(this.countryList);
    // country name
  }

  getRegexValidated() {
    const regEx = new RegExp('(?=.*[0-9])(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z])[a-zA-Z0-9!@#$%^&*]{8,30}$');
    console.warn(regEx.test(this.dataModel.password));
    if (!regEx.test(this.dataModel.password)) {
      return true;
    }
    return false;
  }
}
